exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vuetable-pagination{background:#f9fafb!important}", ""]);

// exports
